import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ShopService } from '../../../../services/shop.service';
import { AuthService } from '../../../../services/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../../services/website-theme.service';
/**
 * Cart Component
 */
let CartComponent = class CartComponent {
    constructor(router, shopService, auth, sanitizer, themeService) {
        this.router = router;
        this.shopService = shopService;
        this.auth = auth;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.products = [];
        this.priceAll = 0;
        this.isValid = true;
        this.backColor = '';
        this.successColor = '';
        this.textColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
    }
    ngOnInit() {
        this._getProducts();
        if (this.products.length > 0) {
            this.calculateAll();
        }
    }
    changeQuantity(type, index, quantity, available) {
        if (type === 'plus' && quantity < available) {
            this.shopService.updateProductByIndex(index, 1);
        }
        if (type === 'minus' && quantity > 0) {
            if (quantity === 1) {
                this.shopService.updateProductByIndex(index, 0);
            }
            else {
                this.shopService.updateProductByIndex(index, -1);
            }
        }
        if (type === 'nono' && quantity > 0) {
            this.shopService.setProductByIndex(index, quantity);
        }
        this.calculateAll();
        this._getProducts();
    }
    checkQuantity() {
        this.isValid = true;
        for (let i = 0; i < this.products.length; i++) {
            if (this.products[i].product.available < this.products[i].quantity) {
                this.changeQuantity('nono', i, this.products[i].product.available, this.products[i].product.available);
                this.isValid = false;
            }
        }
        if (this.isValid) {
            this.router.navigateByUrl('/checkout');
        }
    }
    changeQuantityById(type, id, quantity) {
        if (type === 'plus') {
            this.shopService.updateProduct(id, 1);
        }
        if (type === 'minus') {
            if (quantity === 1) {
                this.shopService.updateProduct(id, 0);
            }
            else {
                this.shopService.updateProduct(id, -1);
            }
        }
        if (type === 'nono') {
            this.shopService.setProduct(id, quantity);
        }
        this.calculateAll();
        this._getProducts();
    }
    formatNumber(num) {
        return ((Math.round(num * 100) / 100)).toFixed(2);
    }
    removeProduct(id) {
        this.shopService.removeProduct(id);
        this.calculateAll();
        this._getProducts();
    }
    calculateAll() {
        this.priceAll = this.shopService.calculateAll();
    }
    _getProducts() {
        this.products = this.shopService.getProducts();
    }
};
CartComponent.ctorParameters = () => [
    { type: Router },
    { type: ShopService },
    { type: AuthService },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
CartComponent = __decorate([
    Component({
        selector: 'ecd-cart',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./cart.component.html")).default
    })
], CartComponent);
export { CartComponent };
